import React from 'react';
import style from '../assets/styles/MainPictureMobileMenu.module.scss';
import { getBtnData, getOneItemColleciton, deleteData } from '../api/Api.js';
import DishesModal from '../component/Dishes/dishesModal.js';
import SubHeaderCustomer from '../component/subHeaderCustomer.js';
import { Link, useNavigate } from 'react-router-dom';
import { CheckUser } from '../Helpers/Helpers.js';
import { GlobalContext } from '../GlobalContext.js';
import { useEnsureAnonymousUser, getAnonymousUser } from '../Hooks/useEnsureAnonymousUser.js';
import WarningMessage from '../component/WarningMessages.js';
import { useCachedImage } from '../Hooks/useCachedImage.js';
import { ensureImagesInCache, nativePreloadImages, getHotCache } from '../util/imageCache.js';
import { doc, getDoc } from 'firebase/firestore';
import { updateDoc, setDoc } from '../api/FirestoreInterceptor';

import { db } from '../config-firebase/firebase.js';
import { AdminBackdoor } from '../Hooks/useAdminBackdoor.js';

const MainPictureMobileMenu = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [dishes, setDishes] = React.useState([]);
  const [menuButton, setMenuButton] = React.useState([]);
  const [dishesFiltered, setDishesFiltered] = React.useState([]);
  const [categorySelected, setCategorySelected] = React.useState('');
  const [item, setItem] = React.useState({});
  const [openModalDishes, setOpenModalDishes] = React.useState(false);
  const [logoutAdminPopup, setLogoutAdminPopup] = React.useState(false);
  const [nameClient, setNameClient] = React.useState('');
  const [showFilteredDishes, setShowFilteredDishes] = React.useState(true);
  const [isSubmittingQuick, setIsSubmittingQuick] = React.useState(false);

  const global = React.useContext(GlobalContext);
  useEnsureAnonymousUser();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (global.isToten) {
      navigate('/');
    }
    const fetchData = async () => {
      try {
        const [data, dataItem, imageLogo] = await Promise.all([
          getBtnData('button'),
          getBtnData('item'),
          (global.image && global.bestSellersImage !== undefined)
            ? Promise.resolve(null)
            : getBtnData('frontImage'),
        ]);

        let logoUrl = global.image;
        let bestSellersImgUrl = global.bestSellersImage;
        if (imageLogo && imageLogo[0]) {
          if (imageLogo[0].image) {
            logoUrl = imageLogo[0].image;
            global.setImage(logoUrl);
          }
          if (imageLogo[0].bestSellersImage !== undefined) {
            bestSellersImgUrl = imageLogo[0].bestSellersImage;
            if (global.setBestSellersImage) {
              global.setBestSellersImage(bestSellersImgUrl);
            }
          }
        }

        const effectiveBestSellerImage =
          bestSellersImgUrl ||
          logoUrl ||
          'https://firebasestorage.googleapis.com/v0/b/react-bar-67f33.appspot.com/o/frontImage%2FWhatsApp%20Image%202024-07-26%20at%2011.19.36.png?alt=media&token=f129a337-ee65-4402-90b2-8ce8a5fb593f';

        const bestSeller = {
          category: 'main',
          parent: 'bestSellers',
          title: 'OS MAIS VENDIDOS ',
          image: effectiveBestSellerImage,
        };
        grabClient();
        if (Array.isArray(data) && data.length > 0) {
          data.unshift(bestSeller);
          const filteredButtonCategory = data.filter((item) => {
            if (item.parent === 'hide') return false;
            if (item.parent === 'bestSellers') return true;

            const hasDishes = Array.isArray(dataItem) && dataItem.some((dish) => dish.category === item.parent && dish.category !== 'hide');
            return hasDishes;
          });

          setMenuButton(filteredButtonCategory);
        }
        const visibleDishes = Array.isArray(dataItem) ? dataItem.filter((dish) => dish.category !== 'hide') : [];
        setDishes(visibleDishes);
        setIsLoading(false);
        if (Array.isArray(visibleDishes) && Array.isArray(data)) {
          nativePreloadImages([...data, ...visibleDishes]);
        }
      } catch (error) {
        console.error('Erro fetching data', error);
      }
    };
    fetchData();
  }, []);

  const CategoryItemImage = ({ item }) => {
    const cacheKey = item.parent === 'bestSellers' || item.id === '1232' ? `bestSellers_${item.image}` : item.id;
    const src = useCachedImage(cacheKey, item.image || 'https://i.pinimg.com/736x/fe/23/38/fe2338260fb041d8d94999fe48cb218f.jpg', 'thumb');
    return <img src={src} alt="" />;
  };

  const DishItemImage = ({ item }) => {
    const src = useCachedImage(item.id, item.image, 'thumb');
    const [imageLoaded, setImageLoaded] = React.useState(() => !!getHotCache(item.id, 'thumb'));

    return (
      <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: '120px' }}>
        {!imageLoaded && <div className={style.skeleton} />}
        <img
          src={src}
          alt=""
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
          className={imageLoaded ? style.loadedImg : style.loadingImg}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  };

  React.useEffect(() => {
    if (dishes.length > 0) {
      chooseCategory('bestSellers', 'OS MAIS VENDIDOS');
    }
  }, [dishes]);

  const chooseCategory = async (parent, title) => {
    if (!dishes || dishes.length === 0) return;

    setCategorySelected(title);
    setShowFilteredDishes(true); // Sempre visível para evitar congelamentos

    const filtered =
      parent !== 'bestSellers'
        ? dishes.filter((item) => item.category === parent && item.category !== 'hide')
        : dishes.filter((item) => item.carrossel === true && item.category !== 'hide');

    // Garante que o IndexedDB seja carregado em background, mas não bloqueia a UI
    ensureImagesInCache(filtered, 'thumb');

    setDishesFiltered(filtered);
  };

  const preparedRequest = async (item) => {
    if (global.hasRawMaterial && item?.lowAmountRawMaterial) return;

    // Detecção de prato simples
    const hasNoSideDishes =
      !item.sideDishesElementList || item.sideDishesElementList.length === 0;

    const hasNoVariations =
      !item.CustomizedPrice ||
      (!Number(item.CustomizedPrice.firstPrice) &&
        !Number(item.CustomizedPrice.secondPrice) &&
        !Number(item.CustomizedPrice.thirdPrice));

    if (hasNoSideDishes && hasNoVariations) {
      await handleDirectOrder(item);
    } else {
      setItem(item);
      setOpenModalDishes(true);
    }
  };

  const handleDirectOrder = async (orderItemData) => {
    if (isSubmittingQuick) return;
    setIsSubmittingQuick(true);

    try {
      let currentUser = '';
      if (localStorage.hasOwnProperty('userMenu')) {
        const currentUserData = JSON.parse(localStorage.getItem('userMenu'));
        currentUser = currentUserData.id;
      }

      if (!global.authorizated) {
        CheckUser('userMenu', global.isToten, global.packageTier).then(path => {
           if (!currentUser) {
               navigate(path);
           }
        });
      }

      if (!currentUser) {
        console.error('Usuário não identificado no localStorage');
        return;
      }

      const orderItem = {
        name: orderItemData.title,
        id: orderItemData.id,
        category: orderItemData.category,
        recipeOpenCloseModal: false,
        finalPrice: Number(orderItemData.price),
        finalCost: orderItemData.costPriceObj?.cost || 0,
        image: orderItemData.image,
        recipe: orderItemData.recipe ? orderItemData.recipe : {},
        sideDishes: [],
        size: orderItemData.CustomizedPrice?.firstLabel || '',
      };

      const userDocRef = doc(db, 'user', currentUser);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const currentRequests = userDocSnap.data().request || [];
        currentRequests.push(orderItem);
        await updateDoc(userDocRef, {
          request: currentRequests,
        });
      } else {
        await setDoc(userDocRef, {
          request: [orderItem],
        });
      }

      const pdv = JSON.parse(localStorage.getItem('pdv') || 'false');
      if (!pdv) {
        navigate('/request', { state: { isAdminOrigin: false } });
        global.setPdvRequest(false);
      } else {
        global.setPdvRequest(true);
        navigate('/admin/requestlist', { state: { isAdminOrigin: true } });
      }
    } catch (error) {
      console.error('Erro ao processar pedido direto (Mobile Menu):', error);
    } finally {
      setIsSubmittingQuick(false);
    }
  };

  const logoutCustomer = async () => {
    if (global.isToten) {
      if (logoutAdminPopup) {
        const anonymousUser = await getAnonymousUser();
        localStorage.setItem(
          'userMenu',
          JSON.stringify({ id: anonymousUser.id, name: anonymousUser.name })
        );
        return;
      }
      setLogoutAdminPopup(true);
    } else {
      localStorage.removeItem('userMenu');
      global.setAuthorizated(false);
      navigate('create-customer');
    }
  };

  function grabClient() {
    if (localStorage.hasOwnProperty('userMenu')) {
      const nameCustomer = JSON.parse(localStorage.getItem('userMenu'));

      let firstName = nameCustomer.name.split(' ')[0];
      firstName =
        firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      setNameClient(firstName);
    }
  }

  async function CheckLogin() {
    const userId = await CheckUser('userMenu');
    navigate(userId);
  }

  return (
    <div className={style.containerMobileImageMenu}>
      {!isLoading && (
        <div
          className={`${style.containerPictureMenu} ${
            !isLoading ? style.loaded : ''
          }`}
        >
          <div className="WarningMessage-container">
            {logoutAdminPopup && (
              <WarningMessage
                message="Você está prestes a sair do sistema"
                setWarningMsg={setLogoutAdminPopup}
                sendRequestToKitchen={logoutCustomer}
              />
            )}
          </div>
          <SubHeaderCustomer
            logoutCustomer={logoutCustomer}
            nameClient={nameClient}
          />
          <div className={style.containerDishes}>
            {openModalDishes && (
              <DishesModal item={item} setModal={setOpenModalDishes} />
            )}
          </div>
          <div className={style.submenu}>
            <nav className={style.categories}>
              {menuButton &&
                menuButton.length > 0 &&
                menuButton.map((item, index) => (
                  <div
                  key={item.id}
                  className={style.categoryItem}
                  onClick={() => chooseCategory(item.parent, item.title)}
                >
                  <h3>{item.title}</h3>
                  <CategoryItemImage item={item} />
                </div>
                ))}
            </nav>
            <section className={style.dishes}>
              <h3 className={style.mainTitle}>{categorySelected}</h3>
              <div className={`${style.subContainer} ${showFilteredDishes ? style.visible : style.hidden}`}>
                {dishesFiltered &&
                  dishesFiltered.length > 0 &&
                  dishesFiltered.map((item, index) => (
                    <div
                      className={style.itemContainer}
                      key={item.id || index} // Evita recriação desnecessária
                    >
                      <div className={style.text}>
                        <h3>{item.title}</h3>
                        <p>{item.comment}</p>
                        <button onClick={() => preparedRequest(item)}>
                          Selecionar
                        </button>
                      </div>
                      <div className={style.image}>
                        <DishItemImage 
                          item={item} 
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </section>
          </div>
        </div>
      )}
      {/* Ponto cego de acesso ao admin (requer 5 cliques rápidos) */}
      <AdminBackdoor className={style.footer} />
    </div>
  );
};
export default MainPictureMobileMenu;
